import React from 'react';

const ComponentAutoLogin = () => {
  return (
    <div>
      ComponentAutoLogin
    </div>
  );
};

export default ComponentAutoLogin;